export const version = '4.6.13';

export const environment = {
    production: true,
    firebase: {
        apiKey: "AIzaSyAa3QjsKChWcdctfzObvbQwbP83wnn1D4k",
        authDomain: "libresalud-51213.firebaseapp.com",
        projectId: "libresalud-51213",
        storageBucket: "libresalud-51213.firebasestorage.app",
        messagingSenderId: "453047145116",
        appId: "1:453047145116:web:ab771369057b38fadf5359",
        // ID de medición del flujo "pwa" en GA4 (Analytics web / PWA).
        measurementId: "G-L326B5LELJ"
    }
};

export const API_URI = 'https://backend.libresalud.com.ar/';

export const VAPID_PUBLIC_KEY = 'BOMVL1wIsJxWn2IOLvYKZLRqdlqwJTr-odRAuWM5nte9Jm0oHBsi0bvfZqiGB1cgB1aj-pdCgiXnJcLQQ9vtBiQ';

//export const API_KEY_GOOGLE_MAPS = 'AIzaSyCkO-M4WmCDtak8H9ztiHjxqjW2O9JsFq0';
export const API_KEY_GOOGLE_MAPS = 'AIzaSyAc710eDHEJYfdLf_1Oo-8kr6u6nyyI3CU';
export const MAP_ID = '195b1b84528ac45d';